import React from 'react'
import { Link, useLocation } from 'react-router-dom'
import { useAuth } from '../hooks/useAuth'

export function Topbar() {
  const { profile, signOut } = useAuth()
  return (
    <>
      <a href="#main-content" className="skip-to-main">Skip to main content</a>
      <header className="topbar" role="banner">
        <Link to="/" className="topbar-brand" aria-label="Notary Signing Vault, LLC - Home" style={{ display:'inline-flex', alignItems:'center' }}>
          <span style={{ display:'inline-flex', alignItems:'center', justifyContent:'center', width:54, height:54, borderRadius:'50%', border:'1px solid #E2E4E7' }}>
            <img
              src="/nsv_emblem.png?v=2"
              alt="Notary Signing Vault, LLC - Nationwide Notary Professionals Network"
              style={{ width:48, height:48, objectFit:'contain', display:'block' }}
            />
          </span>
        </Link>
        <div className="topbar-right">
          <span style={{ fontSize:13, fontWeight:500, color:'#5C6065' }} aria-label={`Signed in as ${profile?.full_name}`}>{profile?.full_name}</span>
          <button onClick={signOut} className="btn btn-sm" aria-label="Sign out of your account" style={{ background:'#EEF0F8', color:'#4D4E8D', border:'1px solid #C7CBE2', fontSize:12 }}>
            Sign out
          </button>
        </div>
      </header>
    </>
  )
}

export function Sidebar({ items }) {
  const loc = useLocation()

  function isActive(item) {
    // ✅ Exact match for dashboard-style routes (end:true)
    if (item.end) return loc.pathname === item.to
    // Otherwise match exact OR child routes
    return loc.pathname === item.to || loc.pathname.startsWith(item.to + '/')
  }

  return (
    <nav className="sidebar" role="navigation" aria-label="Main navigation">
      {items.map((item, i) => (
        item.section
          ? <div key={i} className="sidebar-section" role="heading" aria-level="3">{item.section}</div>
          : <Link key={i} to={item.to}
              className={`sidebar-item ${isActive(item) ? 'active' : ''}`}
              aria-current={isActive(item) ? 'page' : undefined}>
              <span className="sidebar-icon" aria-hidden="true">{item.icon}</span>
              {item.label}
            </Link>
      ))}
    </nav>
  )
}

export function PortalLayout({ sidebarItems, children }) {
  return (
    <>
      <Topbar />
      <div className="app-layout">
        <Sidebar items={sidebarItems} />
        <main className="main-content" id="main-content" role="main" tabIndex="-1">
          {children}
        </main>
      </div>
    </>
  )
}
